var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { CommunicationNetworkGraphTeamPersonExternalEmailLinkInspectorContent } from '@web/components/CommunicationNetworkGraph/components/CommunicationNetworkGraphTeamPersonExternalEmailLinkInspectorContent';
/** CARD-40 — selected employee ↔ External (Emails). */
export var CommunicationNetworkGraphEmployeeScopePersonExternalEmailLinkInspectorContent = function (props) { return (_jsx(CommunicationNetworkGraphTeamPersonExternalEmailLinkInspectorContent, __assign({}, props))); };
